import { render } from "./Inn.vue?vue&type=template&id=c9497f46"
import script from "./Inn.vue?vue&type=script&lang=js"
export * from "./Inn.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__